
/**
 * Internal dependencies
 */
import {
    VISUALDECK_PLANS_RECEIVE,
    VISUALDECK_PLANS_REQUEST,
    VISUALDECK_PLANS_REQUEST_SUCCESS,
    VISUALDECK_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllVisualDeckPlans, requestingVisualDeckPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestVisualDeckPlans = () => (dispatch) => {
    dispatch({
        type: VISUALDECK_PLANS_REQUEST
    });
    return cscom
        .visualDeckPlan()
        .list()
        .then(visualDeckPlans => {
            dispatch({ type: VISUALDECK_PLANS_REQUEST_SUCCESS });
            dispatch({ type: VISUALDECK_PLANS_RECEIVE, payload: { items: visualDeckPlans } });
            return visualDeckPlans;
        })
        .catch((error) => {
            dispatch({ type: VISUALDECK_PLANS_REQUEST_FAILURE, error });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllVisualDeckPlans(getState());
	const requesting = requestingVisualDeckPlans(getState());

	if (plans.length == 0 && requesting == false) {
		return dispatch(requestVisualDeckPlans(...props))
	}

	return plans;
}